import { useQuery } from "@tanstack/react-query";
import { GET_BATCH_VALIDITY_DATE, getBatchValidityDate } from "..";

export const useGetBatchValidityDateQuery = ({ attendanceProgramSelected }) => {
  return useQuery({
    queryKey: [GET_BATCH_VALIDITY_DATE, attendanceProgramSelected],
    queryFn: () => getBatchValidityDate(attendanceProgramSelected),
    enabled: !!attendanceProgramSelected,
  });
};
